import {
    Fragment,
    type ComponentPropsWithoutRef,
    type ComponentType,
    type PropsWithChildren,
} from 'react';

import ErrorBoundary from '../errorBoundary/ErrorBoundary';
import { ThemeProviderBase } from './ThemeProviderBase';

interface AppProviderProps extends PropsWithChildren {
    themeProvider?: ComponentType;
    themeDefaults?: ComponentPropsWithoutRef<typeof ThemeProviderBase>;
}

const AppProvider = ({ themeProvider, themeDefaults, children }: AppProviderProps) => {
    const ThemeProvider = themeProvider ?? Fragment;
    return (
        <ErrorBoundary>
            <ThemeProviderBase {...themeDefaults}>
                <ThemeProvider>{children}</ThemeProvider>
            </ThemeProviderBase>
        </ErrorBoundary>
    );
};

export { AppProvider, AppProvider as default };
